<!-- Toast tasa cambiada -->
<div *ngIf="showRateChangedWarning" class="rate-toast">
  <mat-icon style="font-size: 18px; width: 18px; height: 18px; flex-shrink: 0; color: white;">warning</mat-icon>
  <span style="font-size: 0.82rem; font-weight: 600; line-height: 1.4;">La tasa ha cambiado. Se actualizó el monto a recibir.</span>
</div>

<div class="p-4 md:p-8 step-container-mobile-pad" style="max-width: 520px; margin: 0 auto;">

  <!-- Header con progreso -->
  <div style="background: white; border: 1px solid #e5e7eb; border-radius: 16px; padding: 16px 20px; margin-bottom: 20px;">
    <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 12px;">
      <button type="button" class="btn-tactil" (click)="previousStep()"
        [disabled]="isTransitioning || currentStep === 4"
        [style.opacity]="(isTransitioning || currentStep === 4) ? '0.5' : '1'"
        style="display: inline-flex; align-items: center; gap: 4px; padding: 6px 12px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 8px; font-weight: 600; font-size: 0.8rem; cursor: pointer;"
        onmouseover="if(!this.disabled)this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0; color: #374151;">arrow_back</mat-icon>
        Atrás
      </button>
      <span style="background: #1C593D; color: white; padding: 4px 14px; border-radius: 20px; font-size: 0.8rem; font-weight: 700;">
        Paso {{ currentStep }}/{{ totalSteps }}
      </span>
    </div>
    <div style="width: 100%; height: 8px; background: #dcfce7; border-radius: 20px; overflow: hidden;">
      <div style="height: 100%; background: #1C593D; border-radius: 20px; transition: width 0.3s ease;"
        [style.width.%]="(currentStep / totalSteps) * 100"></div>
    </div>
  </div>

  <!-- ===== STEP 1: Calculadora ===== -->
  <div *ngIf="currentStep === 1" class="step-slide" [class.slide-in-left]="slideDirection === 'left'" [class.slide-in-right]="slideDirection === 'right'">
    <div style="text-align: center; margin-bottom: 20px;">
      <h2 style="font-size: 1.2rem; font-weight: 800; color: #1e5a3f; margin: 0 0 4px;">Convertir USDT a VES</h2>
      <p style="font-size: 0.8rem; color: #6b7280; margin: 0;">Calcula tu conversión en tiempo real</p>
    </div>

    <div style="background: white; border: 1px solid #e5e7eb; border-radius: 16px; overflow: hidden;">
      <!-- Tasa -->
      <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 14px 20px; border-bottom: 2px solid #bbf7d0; text-align: center;">
        <div *ngIf="!loadingRate && !rateError" style="display: flex; align-items: center; justify-content: center; gap: 8px;">
          <img src="assets/icons/USDT_Logo.png" alt="USDT" style="width: 22px; height: 22px; border-radius: 50%; object-fit: cover;">
          <span style="font-size: 1.1rem; font-weight: 800; color: #1e5a3f;">1 USDT = {{ formatVESNumber(tasaUsdtVes) }} VES</span>
          <img src="assets/flags/venezuela.png" alt="VES" style="width: 22px; height: 22px; border-radius: 50%; object-fit: cover;">
        </div>
        <div *ngIf="loadingRate" style="display: flex; align-items: center; justify-content: center; gap: 8px;">
          <mat-spinner diameter="18"></mat-spinner>
          <span style="font-size: 0.82rem; color: #6b7280;">Cargando tasa...</span>
        </div>
        <div *ngIf="rateError && !loadingRate" style="font-size: 0.82rem; color: #dc2626; font-weight: 600;">{{ rateError }}</div>
      </div>

      <div style="padding: 20px;">
        <!-- Saldo -->
        <div style="display: flex; align-items: center; justify-content: space-between; padding: 12px 16px; background: #f9fafb; border: 1px solid #e5e7eb; border-radius: 12px; margin-bottom: 16px;">
          <div style="display: flex; align-items: center; gap: 6px;">
            <img src="assets/icons/USDT_Logo.png" alt="USDT" style="width: 18px; height: 18px; border-radius: 50%; object-fit: cover;">
            <span style="font-size: 0.8rem; font-weight: 600; color: #6b7280;">Saldo disponible</span>
          </div>
          <span style="font-size: 1rem; font-weight: 700; color: #1e5a3f;">{{ formatUSDTWithSymbol(saldoUsdt) }}</span>
        </div>

        <!-- Mensajes info/error -->
        <div *ngIf="tienesSaldo && !errorMessage"
          style="display: flex; align-items: center; gap: 8px; padding: 10px 14px; background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 10px; margin-bottom: 16px;">
          <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0; color: #16a34a;">info</mat-icon>
          <span style="font-size: 0.78rem; font-weight: 500; color: #1e5a3f;">Monto mínimo de conversión <strong>{{ MIN_USDT_AMOUNT }} USDT</strong></span>
        </div>

        <div *ngIf="!tienesSaldo"
          style="display: flex; align-items: center; gap: 8px; padding: 10px 14px; background: #fef3c7; border: 1px solid #fde68a; border-left: 4px solid #f59e0b; border-radius: 10px; margin-bottom: 16px;">
          <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0; color: #f59e0b;">warning</mat-icon>
          <span style="font-size: 0.78rem; font-weight: 600; color: #92400e;">Saldo insuficiente. <strong>Recarga tu cuenta</strong> para realizar conversiones</span>
        </div>

        <div *ngIf="errorMessage && tienesSaldo"
          style="display: flex; align-items: center; gap: 8px; padding: 10px 14px; background: #fef2f2; border: 1px solid #fecaca; border-left: 4px solid #dc2626; border-radius: 10px; margin-bottom: 16px;">
          <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0; color: #dc2626;">error</mat-icon>
          <span style="font-size: 0.78rem; font-weight: 600; color: #991b1b;">{{ errorMessage }}</span>
        </div>

        <div *ngIf="!isOperatingHours"
          style="display: flex; align-items: center; gap: 8px; padding: 10px 14px; background: #fef2f2; border: 1px solid #fecaca; border-left: 4px solid #dc2626; border-radius: 10px; margin-bottom: 16px;">
          <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0; color: #dc2626;">schedule</mat-icon>
          <span style="font-size: 0.78rem; font-weight: 600; color: #991b1b;">Fuera de horario. Operamos de <strong>{{ horarioOperacion }}</strong> (hora Venezuela)</span>
        </div>

        <!-- Input USDT -->
        <div style="margin-bottom: 16px;">
          <label style="display: flex; align-items: center; gap: 6px; font-size: 0.8rem; font-weight: 600; color: #1e5a3f; margin-bottom: 6px;">
            <img src="assets/icons/USDT_Logo.png" alt="USDT" style="width: 16px; height: 16px; border-radius: 50%; object-fit: cover;">
            Tú envías
          </label>
          <div style="position: relative;">
            <span style="position: absolute; left: 14px; top: 50%; transform: translateY(-50%); color: #1e5a3f; font-weight: 700; font-size: 0.82rem; pointer-events: none; z-index: 2; display: flex; align-items: center; gap: 4px;">
              <img src="assets/icons/USDT_Logo.png" alt="USDT" style="width: 16px; height: 16px; border-radius: 50%; object-fit: cover;">
              USDT
            </span>
            <!-- `type=text` + `appMonto`: separador de miles en vivo (ver nota
                 en `convert-usdt-clp`). -->
            <input type="text" inputmode="numeric" appMonto [decimales]="2"
              [(ngModel)]="montoAConvertir"
              (ngModelChange)="calcularConversion()"
              placeholder="0"
              [disabled]="!isOperatingHours"
              class="calc-input"
              style="width: 100%; padding: 14px 80px 14px 78px; border: 2px solid #e5e7eb; border-radius: 12px; font-size: 1.1rem; font-weight: 700; color: #1e5a3f; background: white; text-align: right; outline: none; box-sizing: border-box; transition: border-color 0.2s;"
              onfocus="this.style.borderColor='#34d399'" onblur="this.style.borderColor='#e5e7eb'">
            <button type="button" class="btn-tactil"
              [disabled]="!isOperatingHours || !tienesSaldo"
              (click)="usarMaximo()"
              [style.opacity]="(!isOperatingHours || !tienesSaldo) ? '0.5' : '1'"
              style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%); background: #1C593D; color: white; border: none; border-radius: 8px; padding: 4px 12px; font-size: 0.75rem; font-weight: 700; cursor: pointer; transition: background 0.2s;"
              onmouseover="if(!this.disabled)this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
              MÁX
            </button>
          </div>
        </div>

        <!-- Arrow -->
        <div style="display: flex; justify-content: center; margin-bottom: 12px;">
          <div style="width: 36px; height: 36px; background: #1C593D; border-radius: 50%; display: flex; align-items: center; justify-content: center;">
            <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: white;">arrow_downward</mat-icon>
          </div>
        </div>

        <!-- Input VES -->
        <div style="margin-bottom: 16px;">
          <label style="display: flex; align-items: center; gap: 6px; font-size: 0.8rem; font-weight: 600; color: #1e5a3f; margin-bottom: 6px;">
            <img src="assets/flags/venezuela.png" alt="VES" style="width: 16px; height: 16px; border-radius: 50%; object-fit: cover;">
            Recibes
          </label>
          <div style="position: relative;">
            <span style="position: absolute; left: 14px; top: 50%; transform: translateY(-50%); color: #1e5a3f; font-weight: 700; font-size: 0.82rem; pointer-events: none; z-index: 2; display: flex; align-items: center; gap: 4px;">
              <img src="assets/flags/venezuela.png" alt="VES" style="width: 16px; height: 16px; border-radius: 50%; object-fit: cover;">
              VES
            </span>
            <input type="text"
              [value]="formatVESNumber(montoConvertido)"
              readonly
              placeholder="0,00"
              style="width: 100%; padding: 14px 16px 14px 72px; border: 2px solid #e5e7eb; border-radius: 12px; font-size: 1.1rem; font-weight: 700; color: #1e5a3f; background: #f9fafb; text-align: right; outline: none; box-sizing: border-box;">
          </div>
        </div>

        <!-- Escalera de tramos: «Tu tasa», «Tramo k de N», lo que recibe de
             más, lo que falta y la lista plegada. Sin escalera no se dibuja
             nada y la pantalla queda como antes. En el celular acá va solo el
             teaser de una línea; la completa, debajo del botón. Formato
             en-US, el del campo de monto. -->
        <app-escalera-tramos
          *ngIf="tasaUsdtVes > 0 && !loadingRate && escaleraUsdtVes as esc"
          class="usdt-ves-escalera usdt-ves-escalera--arriba"
          posicion="arriba"
          locale="en-US"
          [escalera]="esc"
          [monto]="montoAConvertir"
          moneda="USDT"
          monedaDestino="VES"
          tipoAhorro="RECIBE_MAS"
          decimales="1.2-2"
          [tasaAplicada]="tasaUsdtVes"
          [tasaReferencia]="tasaBaseUsdtVes"
          simbolo="Bs."
          unidad="Bs. por 1 USDT"
          idBase="esc-usdt-ves"
          [compacta]="true"
          [permitirUsar]="isOperatingHours"
          [montoMaximo]="saldoUsdt"
          (usarMonto)="usarMontoUsdt($event)"
        ></app-escalera-tramos>

        <!-- Detalles -->
        <div style="background: #f9fafb; border: 1px solid #e5e7eb; border-radius: 12px; padding: 12px 16px; margin-bottom: 16px;">
          <div style="display: flex; align-items: center; gap: 8px; padding: 8px 0; border-bottom: 1px solid #e5e7eb;">
            <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0; color: #1C593D;">currency_exchange</mat-icon>
            <span style="flex: 1; font-size: 0.78rem; color: #6b7280; font-weight: 500;">Tipo de cambio:</span>
            <span style="font-size: 0.78rem; font-weight: 700; color: #1e5a3f;">1 USDT = {{ formatVESNumber(tasaUsdtVes) }} VES</span>
          </div>
          <div style="display: flex; align-items: center; gap: 8px; padding: 8px 0;">
            <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0; color: #1C593D;">schedule</mat-icon>
            <span style="flex: 1; font-size: 0.78rem; color: #6b7280; font-weight: 500;">Horario:</span>
            <span style="font-size: 0.78rem; font-weight: 700; color: #1e5a3f;">{{ horarioOperacion }}</span>
          </div>
        </div>

        <!-- Confirmación monto -->
        <div *ngIf="montoConvertido > 0 && isValidAmount"
          style="display: flex; align-items: center; gap: 8px; padding: 10px 14px; background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 10px; margin-bottom: 16px;">
          <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0; color: #16a34a;">check_circle</mat-icon>
          <span style="font-size: 0.78rem; font-weight: 500; color: #1e5a3f;">Recibirás <strong>{{ formatVES(montoConvertido) }}</strong></span>
        </div>

        <!-- Tramo del monto: mejora la base. Con escalera lo dice `app-escalera-tramos`. -->
        <div *ngIf="extraVesTramo > 0 && montoConvertido > 0 && isValidAmount && !escaleraUsdtVes"
          style="display: flex; align-items: center; gap: 8px; padding: 10px 14px; background: #ecfdf5; border: 1px solid #a7f3d0; border-radius: 10px; margin-bottom: 16px;">
          <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0; color: #059669;">trending_up</mat-icon>
          <span style="font-size: 0.78rem; font-weight: 500; color: #065f46;">
            Por este monto recibes <strong>{{ formatVES(extraVesTramo) }}</strong> más que con la tasa base.
          </span>
        </div>

      </div>
    </div>

    <!-- Botón acción (fuera de la card para sticky móvil) -->
    <div class="step-actions">
      <button type="button" (click)="onButtonClick()"
        [disabled]="isButtonDisabled"
        [style.opacity]="isButtonDisabled ? '0.5' : '1'"
        [style.cursor]="isButtonDisabled ? 'not-allowed' : 'pointer'"
        [style.background]="!tienesSaldo ? '#f59e0b' : '#1C593D'"
        style="width: 100%; display: flex; align-items: center; justify-content: center; gap: 8px; padding: 14px; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.95rem; cursor: pointer; transition: all 0.2s ease;"
        (mouseover)="$any($event.target).style.background = !tienesSaldo ? '#d97706' : isButtonDisabled ? '#1C593D' : '#059669'"
        (mouseout)="$any($event.target).style.background = !tienesSaldo ? '#f59e0b' : '#1C593D'">
        <mat-icon *ngIf="!isConverting && !isLoadingButton" style="font-size: 18px; width: 18px; height: 18px; color: white;">
          {{ !tienesSaldo ? 'account_balance_wallet' : 'arrow_forward' }}
        </mat-icon>
        <mat-spinner *ngIf="isLoadingButton" diameter="18" style="display: inline-block;"></mat-spinner>
        <mat-icon *ngIf="isConverting && !isLoadingButton" style="font-size: 18px; width: 18px; height: 18px; color: white;">hourglass_top</mat-icon>
        {{ buttonText }}
      </button>
    </div>

    <!-- Celular (bajo 768 px): la escalera completa, debajo del botón. -->
    <app-escalera-tramos
      *ngIf="tasaUsdtVes > 0 && !loadingRate && escaleraUsdtVes as esc"
      class="usdt-ves-escalera"
      posicion="abajo"
      locale="en-US"
      [escalera]="esc"
      [monto]="montoAConvertir"
      moneda="USDT"
      monedaDestino="VES"
      tipoAhorro="RECIBE_MAS"
      decimales="1.2-2"
      [tasaAplicada]="tasaUsdtVes"
      [tasaReferencia]="tasaBaseUsdtVes"
      simbolo="Bs."
      unidad="Bs. por 1 USDT"
      idBase="esc-usdt-ves"
      [compacta]="true"
      [permitirUsar]="isOperatingHours"
      [montoMaximo]="saldoUsdt"
      (usarMonto)="usarMontoUsdt($event)"
    ></app-escalera-tramos>
  </div>

  <!-- ===== STEP 2: Wallet Confirmation OR Beneficiary Selection ===== -->
  <div *ngIf="currentStep === 2" class="step-slide" [class.slide-in-left]="slideDirection === 'left'" [class.slide-in-right]="slideDirection === 'right'">

    <!-- WALLET PATH: Confirmación directa -->
    <ng-container *ngIf="destination === 'wallet'">
      <div style="text-align: center; margin-bottom: 20px;">
        <h2 style="font-size: 1.2rem; font-weight: 800; color: #1e5a3f; margin: 0 0 4px;">Confirma tu operación</h2>
        <p style="font-size: 0.8rem; color: #6b7280; margin: 0;">Los VES se guardarán en tu Wallet Aguacate</p>
      </div>

      <div style="background: white; border: 1px solid #e5e7eb; border-radius: 16px; padding: 20px; margin-bottom: 16px;">
        <h3 style="font-size: 0.95rem; font-weight: 700; color: #1e5a3f; margin: 0 0 16px;">Resumen de operación</h3>

        <!-- Destino -->
        <div style="padding-bottom: 14px; border-bottom: 1px solid #e5e7eb; margin-bottom: 14px;">
          <span style="font-size: 0.72rem; color: #6b7280; font-weight: 500;">Destino</span>
          <p style="font-size: 0.88rem; font-weight: 600; color: #1e5a3f; margin: 2px 0 0; display: flex; align-items: center; gap: 6px;">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #1C593D;">account_balance_wallet</mat-icon>
            Wallet VES Aguacate
          </p>
        </div>

        <!-- Montos -->
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-3" style="margin-bottom: 14px;">
          <div style="background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 12px; padding: 14px; text-align: center;">
            <span style="font-size: 0.7rem; color: #6b7280; font-weight: 500; text-transform: uppercase;">Tú envías</span>
            <p style="font-size: 1.2rem; font-weight: 800; color: #1e5a3f; margin: 4px 0 6px;">{{ formatUSDT(montoAConvertir) }}</p>
            <span style="display: inline-flex; align-items: center; gap: 4px; background: white; padding: 3px 10px; border-radius: 12px; font-size: 0.72rem; font-weight: 600; color: #1e5a3f;">
              <img src="assets/icons/USDT_Logo.png" alt="USDT" style="width: 16px; height: 16px; border-radius: 50%; object-fit: cover;">
              USDT
            </span>
          </div>
          <div style="background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 12px; padding: 14px; text-align: center;">
            <span style="font-size: 0.7rem; color: #6b7280; font-weight: 500; text-transform: uppercase;">Recibes en wallet</span>
            <p style="font-size: 1.2rem; font-weight: 800; color: #1e5a3f; margin: 4px 0 6px;">{{ formatVESNumber(montoConvertido) }}</p>
            <span style="display: inline-flex; align-items: center; gap: 4px; background: white; padding: 3px 10px; border-radius: 12px; font-size: 0.72rem; font-weight: 600; color: #1e5a3f;">
              <img src="assets/flags/venezuela.png" alt="VES" style="width: 16px; height: 16px; border-radius: 50%; object-fit: cover;">
              VES
            </span>
          </div>
        </div>

        <!-- Detalles -->
        <div style="display: flex; align-items: center; gap: 8px; padding: 10px 0; border-bottom: 1px solid #e5e7eb;">
          <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0; color: #1C593D;">currency_exchange</mat-icon>
          <span style="flex: 1; font-size: 0.78rem; color: #6b7280;">Tipo de cambio:</span>
          <span style="font-size: 0.78rem; font-weight: 700; color: #1e5a3f;">1 USDT = {{ formatVESNumber(tasaUsdtVes) }} VES</span>
        </div>
        <div style="display: flex; align-items: center; gap: 8px; padding: 10px 0;">
          <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0; color: #1C593D;">bolt</mat-icon>
          <span style="flex: 1; font-size: 0.78rem; color: #6b7280;">Disponibilidad:</span>
          <span style="font-size: 0.78rem; font-weight: 700; color: #1e5a3f;">Inmediata</span>
        </div>
      </div>

      <!-- Confirmar -->
      <div class="step-actions">
        <button type="button" (click)="nextStep()"
          [disabled]="isConverting || isTransitioning"
          [style.opacity]="(isConverting || isTransitioning) ? '0.5' : '1'"
          [style.cursor]="(isConverting || isTransitioning) ? 'not-allowed' : 'pointer'"
          style="width: 100%; display: flex; align-items: center; justify-content: center; gap: 8px; padding: 14px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.95rem; cursor: pointer; transition: background 0.2s;"
          onmouseover="if(!this.disabled)this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">{{ isConverting ? 'hourglass_top' : 'check_circle' }}</mat-icon>
          {{ isConverting ? 'Procesando...' : 'Confirmar' }}
        </button>
      </div>
    </ng-container>

    <!-- WITHDRAW PATH: Selección de beneficiario -->
    <ng-container *ngIf="destination === 'withdraw'">
      <div style="text-align: center; margin-bottom: 20px;">
        <h2 style="font-size: 1.2rem; font-weight: 800; color: #1e5a3f; margin: 0 0 4px;">Beneficiario</h2>
        <p style="font-size: 0.8rem; color: #6b7280; margin: 0;">Selecciona o agrega tu beneficiario</p>
      </div>

      <div style="background: white; border: 1px solid #e5e7eb; border-radius: 16px; padding: 20px;">
        <!-- Loading beneficiarios -->
        <div *ngIf="loadingBeneficiarios" style="text-align: center; padding: 30px;">
          <mat-spinner diameter="32" style="margin: 0 auto 12px;"></mat-spinner>
          <p style="font-size: 0.82rem; color: #6b7280;">Cargando beneficiarios...</p>
        </div>

        <ng-container *ngIf="!loadingBeneficiarios">
          <!-- Buscar -->
          <div style="position: relative; margin-bottom: 16px;">
            <mat-icon style="position: absolute; left: 14px; top: 50%; transform: translateY(-50%); font-size: 18px; width: 18px; height: 18px; color: #9ca3af;">search</mat-icon>
            <input type="text" [(ngModel)]="searchTerm" placeholder="Buscar contacto"
              style="width: 100%; padding: 12px 16px 12px 42px; border: 2px solid #e5e7eb; border-radius: 12px; font-size: 0.9rem; outline: none; box-sizing: border-box; transition: border-color 0.2s;"
              onfocus="this.style.borderColor='#34d399'" onblur="this.style.borderColor='#e5e7eb'">
          </div>

          <!-- Agregar beneficiario -->
          <button type="button" (click)="openAddBeneficiaryDialog()"
            style="width: 100%; padding: 12px; border: 2px dashed #1C593D; background: white; color: #1C593D; border-radius: 12px; font-size: 0.85rem; font-weight: 600; cursor: pointer; margin-bottom: 20px; transition: all 0.2s;"
            onmouseover="this.style.background='#f0fdf4'" onmouseout="this.style.background='white'">
            <mat-icon style="font-size: 16px; width: 16px; height: 16px; vertical-align: middle; margin-right: 4px; color: #1C593D;">add</mat-icon>
            Agregar beneficiario
          </button>

          <!-- Lista -->
          <div style="margin-bottom: 16px;">
            <h3 style="font-size: 0.85rem; font-weight: 700; color: #1e5a3f; margin: 0 0 12px;">Tus beneficiarios</h3>
            <div style="display: flex; flex-direction: column; gap: 10px; max-height: 300px; overflow-y: auto;">
              <label *ngFor="let beneficiary of filteredBeneficiaries"
                style="display: flex; align-items: center; gap: 12px; padding: 14px; border: 2px solid; border-radius: 12px; cursor: pointer; transition: all 0.2s;"
                [style.borderColor]="selectedBeneficiary?.cuentaBeneficiarioID === beneficiary.cuentaBeneficiarioID ? '#1C593D' : '#e5e7eb'"
                [style.background]="selectedBeneficiary?.cuentaBeneficiarioID === beneficiary.cuentaBeneficiarioID ? '#f0fdf4' : 'white'">
                <input type="radio" name="beneficiary" [value]="beneficiary.cuentaBeneficiarioID"
                  [checked]="selectedBeneficiary?.cuentaBeneficiarioID === beneficiary.cuentaBeneficiarioID"
                  (change)="selectBeneficiary(beneficiary)" style="display: none;">
                <!-- Avatar -->
                <div style="width: 42px; height: 42px; border-radius: 50%; background: linear-gradient(135deg, #1C593D, #34d399); display: flex; align-items: center; justify-content: center; color: white; font-size: 1rem; font-weight: 700; flex-shrink: 0;">
                  {{ beneficiary.nombre.charAt(0) }}
                </div>
                <div style="flex: 1; min-width: 0;">
                  <span style="display: block; font-size: 0.85rem; font-weight: 600; color: #1e5a3f;">{{ beneficiary.nombre }} {{ beneficiary.apellidos }}</span>
                  <span style="display: flex; align-items: center; gap: 4px; font-size: 0.75rem; color: #6b7280;">
                    <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #9ca3af;">account_balance</mat-icon>
                    {{ beneficiary.banco?.nombre }} - {{ beneficiary.numeroCuenta }}
                  </span>
                </div>
                <!-- Radio visual -->
                <div style="width: 22px; height: 22px; border-radius: 50%; border: 2px solid; flex-shrink: 0; display: flex; align-items: center; justify-content: center;"
                  [style.borderColor]="selectedBeneficiary?.cuentaBeneficiarioID === beneficiary.cuentaBeneficiarioID ? '#1C593D' : '#d1d5db'"
                  [style.background]="selectedBeneficiary?.cuentaBeneficiarioID === beneficiary.cuentaBeneficiarioID ? '#1C593D' : 'white'">
                  <div *ngIf="selectedBeneficiary?.cuentaBeneficiarioID === beneficiary.cuentaBeneficiarioID"
                    style="width: 8px; height: 8px; background: white; border-radius: 50%;"></div>
                </div>
              </label>

              <!-- Empty state -->
              <div *ngIf="filteredBeneficiaries.length === 0"
                style="text-align: center; padding: 30px 16px; border: 2px dashed #e5e7eb; border-radius: 12px;">
                <mat-icon style="font-size: 40px; width: 40px; height: 40px; color: #d1d5db; margin-bottom: 8px;">people</mat-icon>
                <p style="font-size: 0.9rem; font-weight: 600; color: #1e5a3f; margin: 0 0 4px;">No tienes beneficiarios registrados</p>
                <p style="font-size: 0.78rem; color: #6b7280; margin: 0;">Agrega uno para continuar</p>
              </div>
            </div>
          </div>

        </ng-container>
      </div>

      <!-- Continuar (fuera de la card para sticky móvil) -->
      <div class="step-actions">
        <button type="button" (click)="nextStep()"
          [disabled]="!selectedBeneficiary || isTransitioning"
          [style.opacity]="(!selectedBeneficiary || isTransitioning) ? '0.5' : '1'"
          [style.cursor]="(!selectedBeneficiary || isTransitioning) ? 'not-allowed' : 'pointer'"
          style="width: 100%; display: flex; align-items: center; justify-content: center; gap: 8px; padding: 14px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.95rem; cursor: pointer; transition: background 0.2s;"
          onmouseover="if(!this.disabled)this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">arrow_forward</mat-icon>
          Continuar
        </button>
      </div>
    </ng-container>
  </div>

  <!-- ===== STEP 3: Resumen con beneficiario (solo withdraw path) ===== -->
  <div *ngIf="currentStep === 3" class="step-slide" [class.slide-in-left]="slideDirection === 'left'" [class.slide-in-right]="slideDirection === 'right'">
    <div style="text-align: center; margin-bottom: 20px;">
      <h2 style="font-size: 1.2rem; font-weight: 800; color: #1e5a3f; margin: 0 0 4px;">Valida tu operación</h2>
      <p style="font-size: 0.8rem; color: #6b7280; margin: 0;">Revisa que todos los datos estén bien</p>
    </div>

    <div style="background: white; border: 1px solid #e5e7eb; border-radius: 16px; padding: 20px; margin-bottom: 16px;">
      <h3 style="font-size: 0.95rem; font-weight: 700; color: #1e5a3f; margin: 0 0 16px;">Resumen de operación</h3>

      <!-- Beneficiario -->
      <div style="padding-bottom: 14px; border-bottom: 1px solid #e5e7eb; margin-bottom: 14px;">
        <span style="font-size: 0.72rem; color: #6b7280; font-weight: 500;">Beneficiario</span>
        <p style="font-size: 0.88rem; font-weight: 600; color: #1e5a3f; margin: 2px 0 0;">
          {{ getSelectedBeneficiaryName() }} - {{ getSelectedBeneficiaryBank() }}
        </p>
      </div>

      <!-- Montos -->
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-3" style="margin-bottom: 14px;">
        <div style="background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 12px; padding: 14px; text-align: center;">
          <span style="font-size: 0.7rem; color: #6b7280; font-weight: 500; text-transform: uppercase;">Tú envías</span>
          <p style="font-size: 1.2rem; font-weight: 800; color: #1e5a3f; margin: 4px 0 6px;">{{ formatUSDT(montoAConvertir) }}</p>
          <span style="display: inline-flex; align-items: center; gap: 4px; background: white; padding: 3px 10px; border-radius: 12px; font-size: 0.72rem; font-weight: 600; color: #1e5a3f;">
            <img src="assets/icons/USDT_Logo.png" alt="USDT" style="width: 16px; height: 16px; border-radius: 50%; object-fit: cover;">
            USDT
          </span>
        </div>
        <div style="background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 12px; padding: 14px; text-align: center;">
          <span style="font-size: 0.7rem; color: #6b7280; font-weight: 500; text-transform: uppercase;">Beneficiario recibe</span>
          <p style="font-size: 1.2rem; font-weight: 800; color: #1e5a3f; margin: 4px 0 6px;">{{ formatVESNumber(montoConvertido) }}</p>
          <span style="display: inline-flex; align-items: center; gap: 4px; background: white; padding: 3px 10px; border-radius: 12px; font-size: 0.72rem; font-weight: 600; color: #1e5a3f;">
            <img src="assets/flags/venezuela.png" alt="VES" style="width: 16px; height: 16px; border-radius: 50%; object-fit: cover;">
            VES
          </span>
        </div>
      </div>

      <!-- Detalles -->
      <div style="display: flex; align-items: center; gap: 8px; padding: 10px 0; border-bottom: 1px solid #e5e7eb;">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0; color: #1C593D;">currency_exchange</mat-icon>
        <span style="flex: 1; font-size: 0.78rem; color: #6b7280;">Tipo de cambio:</span>
        <span style="font-size: 0.78rem; font-weight: 700; color: #1e5a3f;">1 USDT = {{ formatVESNumber(tasaUsdtVes) }} VES</span>
      </div>
      <div style="display: flex; align-items: center; gap: 8px; padding: 10px 0;">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0; color: #1C593D;">timer</mat-icon>
        <span style="flex: 1; font-size: 0.78rem; color: #6b7280;">Tiempo estimado:</span>
        <span style="font-size: 0.78rem; font-weight: 700; color: #1e5a3f;">15 minutos</span>
      </div>
    </div>

    <!-- Confirmar -->
    <div class="step-actions">
      <button type="button" (click)="nextStep()"
        [disabled]="isConverting || isTransitioning"
        [style.opacity]="(isConverting || isTransitioning) ? '0.5' : '1'"
        [style.cursor]="(isConverting || isTransitioning) ? 'not-allowed' : 'pointer'"
        style="width: 100%; display: flex; align-items: center; justify-content: center; gap: 8px; padding: 14px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.95rem; cursor: pointer; transition: background 0.2s;"
        onmouseover="if(!this.disabled)this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
        <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">{{ isConverting ? 'hourglass_top' : 'check_circle' }}</mat-icon>
        {{ isConverting ? 'Procesando...' : 'Confirmar' }}
      </button>
    </div>
  </div>

  <!-- ===== STEP 4: Resultado incierto (sin reintento) ===== -->
  <div *ngIf="currentStep === 4 && envioIncierto" class="step-slide slide-in-left">
    <div style="display: flex; flex-direction: column; align-items: center; text-align: center;">
      <mat-icon style="font-size: 56px; width: 56px; height: 56px; color: #C98A00; margin: 20px 0 12px;">hourglass_top</mat-icon>
      <h2 style="font-size: 1.2rem; font-weight: 800; color: #1e5a3f; margin: 0 0 8px;">No pudimos confirmar tu operación</h2>
      <p style="font-size: 0.85rem; color: #6b7280; margin: 0 0 20px; line-height: 1.5;">{{ mensajeIncierto }}</p>
      <div class="step-actions">
        <button type="button" (click)="irAlHistorial()"
          style="width: 100%; display: flex; align-items: center; justify-content: center; gap: 8px; padding: 14px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.95rem; cursor: pointer; transition: background 0.2s;"
          onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">history</mat-icon>
          Revisar mi historial
        </button>
      </div>
    </div>
  </div>

  <!-- ===== STEP 4: Éxito ===== -->
  <div *ngIf="currentStep === 4 && !envioIncierto" class="step-slide slide-in-left">
    <div style="display: flex; flex-direction: column; align-items: center;">
      <!-- Aguacate image -->
      <img src="assets/icons/aguacatepay.svg" alt="AguacatePay" style="width: 160px; height: 160px; margin: 10px 0 20px;">

      <h2 style="font-size: 1.2rem; font-weight: 800; color: #1e5a3f; margin: 0 0 4px; text-align: center;">{{ destination === 'wallet' ? 'Conversión realizada' : 'Transacción creada' }}</h2>
      <p style="font-size: 0.8rem; color: #6b7280; margin: 0 0 20px; text-align: center;">{{ destination === 'wallet' ? 'Los bolívares quedaron en tu saldo VES' : 'La operación fue realizada con éxito' }}</p>

      <!-- Resumen -->
      <div style="width: 100%; background: white; border: 1px solid #e5e7eb; border-radius: 16px; padding: 20px; margin-bottom: 16px;">
        <!-- Destino -->
        <div style="padding-bottom: 14px; border-bottom: 1px solid #e5e7eb; margin-bottom: 14px;">
          <span style="font-size: 0.72rem; color: #6b7280; font-weight: 500;">{{ destination === 'wallet' ? 'Destino' : 'Beneficiario' }}</span>
          <p style="font-size: 0.88rem; font-weight: 600; color: #1e5a3f; margin: 2px 0 0;">
            <ng-container *ngIf="destination === 'wallet'">
              <span style="display: flex; align-items: center; gap: 6px;">
                <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #1C593D;">account_balance_wallet</mat-icon>
                Wallet VES Aguacate
              </span>
            </ng-container>
            <ng-container *ngIf="destination === 'withdraw'">
              {{ getSelectedBeneficiaryName() }} - {{ getSelectedBeneficiaryBank() }}
            </ng-container>
          </p>
        </div>

        <div class="grid grid-cols-1 sm:grid-cols-2 gap-3" style="margin-bottom: 14px;">
          <div style="background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 12px; padding: 14px; text-align: center;">
            <span style="font-size: 0.7rem; color: #6b7280; font-weight: 500; text-transform: uppercase;">Tú envías</span>
            <p style="font-size: 1.2rem; font-weight: 800; color: #1e5a3f; margin: 4px 0 6px;">{{ formatUSDT(montoAConvertir) }}</p>
            <span style="display: inline-flex; align-items: center; gap: 4px; background: white; padding: 3px 10px; border-radius: 12px; font-size: 0.72rem; font-weight: 600; color: #1e5a3f;">
              <img src="assets/icons/USDT_Logo.png" alt="USDT" style="width: 16px; height: 16px; border-radius: 50%; object-fit: cover;">
              USDT
            </span>
          </div>
          <div style="background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 12px; padding: 14px; text-align: center;">
            <span style="font-size: 0.7rem; color: #6b7280; font-weight: 500; text-transform: uppercase;">{{ destination === 'wallet' ? 'Recibes en wallet' : 'Beneficiario recibe' }}</span>
            <p style="font-size: 1.2rem; font-weight: 800; color: #1e5a3f; margin: 4px 0 6px;">{{ formatVESNumber(vesLiquidados) }}</p>
            <span style="display: inline-flex; align-items: center; gap: 4px; background: white; padding: 3px 10px; border-radius: 12px; font-size: 0.72rem; font-weight: 600; color: #1e5a3f;">
              <img src="assets/flags/venezuela.png" alt="VES" style="width: 16px; height: 16px; border-radius: 50%; object-fit: cover;">
              VES
            </span>
          </div>
        </div>

        <div style="display: flex; align-items: center; justify-content: center; gap: 8px; padding: 10px 14px; background: #eff6ff; border: 1px solid #bfdbfe; border-radius: 10px;">
          <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0; color: #2563eb;">{{ destination === 'wallet' ? 'bolt' : 'timer' }}</mat-icon>
          <span style="font-size: 0.78rem; font-weight: 600; color: #1e40af;">
            {{ destination === 'wallet' ? 'Disponible de inmediato en tu wallet' : 'Tu dinero llegará en 15 minutos' }}
          </span>
        </div>
      </div>

      <!-- Botones -->
      <div class="step-actions">
        <button type="button" (click)="shareTransaction()"
          style="width: 100%; display: inline-flex; align-items: center; justify-content: center; gap: 8px; padding: 12px; background: white; color: #1C593D; border: 2px solid #1C593D; border-radius: 10px; font-weight: 600; font-size: 0.88rem; cursor: pointer; margin-bottom: 10px; transition: all 0.2s;"
          onmouseover="this.style.background='#f0fdf4'" onmouseout="this.style.background='white'">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #1C593D;">share</mat-icon>
          Compartir operación
        </button>

        <button type="button" (click)="finishTransaction()"
          style="width: 100%; display: flex; align-items: center; justify-content: center; gap: 8px; padding: 14px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.95rem; cursor: pointer; transition: background 0.2s;"
          onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">check</mat-icon>
          Finalizar
        </button>
      </div>
    </div>
  </div>

</div>
